export const SERVING_URL_DOMAIN_REGEXP =
  /^https?:\/\/lh\d+.googleusercontent.com/;

/**
 * ServingURLのドメインであるか
 * @param url
 * @returns
 */
export const isServingUrl = (url: string) =>
  url.match(SERVING_URL_DOMAIN_REGEXP);

export const resizeServingUrl = (
  url: string,
  pxWidth: number,
  isCrop: boolean = false,
) => {
  // urlがnullまたは `=` など既にクエリパラメータが入っているときは指定しない
  if (!isServingUrl(url) || /=/.test(url)) return url;

  return `${url}=s${pxWidth}${isCrop ? "-p" : ""}-rw`;
};
